export enum ControlStaticType {
  RADIO,
  CHECKBOX,
}
